import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserRole } from "@/types";
import { UserRole as UserRoleEnum } from "@/types/enums";
import { Textarea } from "@/components/ui/textarea";

interface ContactInfoProps {
  contactPerson: string;
  contactEmail: string;
  contactRole: string;
  contactPhone?: string;
  address?: string;
  contactPassword?: string;
  onChange: (key: string, value: string) => void;
}

const ROLE_OPTIONS: { label: string; value: UserRole }[] = [
  { label: "App Owner", value: UserRoleEnum.APP_OWNER },
  { label: "Super Admin", value: UserRoleEnum.SUPER_ADMIN },
  { label: "HR", value: UserRoleEnum.HR },
];

export const ContactInfoSection = ({
  contactPerson,
  contactEmail,
  contactRole,
  contactPhone,
  address,
  contactPassword,
  onChange
}: ContactInfoProps) => {
  return (
    <div>
      <Label htmlFor="contact-section" className="text-base font-semibold">
        Contact Information
      </Label>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
        <div>
          <Label htmlFor="contact-person" className="text-sm">
            Contact Person
          </Label>
          <Input 
            id="contact-person"
            value={contactPerson}
            onChange={(e) => onChange("contact_person", e.target.value)}
            className="mt-1"
          />
        </div>
        
        <div>
          <Label htmlFor="contact-email" className="text-sm">
            Contact Email <span className="text-red-500">*</span>
          </Label>
          <Input 
            id="contact-email"
            type="email"
            value={contactEmail}
            onChange={(e) => onChange("contact_email", e.target.value)}
            className="mt-1"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <Label htmlFor="contact-role" className="text-sm">
            Contact Role <span className="text-red-500">*</span>
          </Label>
          <Select
            value={contactRole}
            onValueChange={(value) => onChange("contact_role", value)}
          >
            <SelectTrigger className="mt-1">
              <SelectValue placeholder="Select role" />
            </SelectTrigger>
            <SelectContent>
              {ROLE_OPTIONS.map(option => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Label htmlFor="contact-password" className="text-sm">
            Contact Password
          </Label>
          <Input 
            id="contact-password"
            type="password"
            placeholder="Create password for contact person"
            value={contactPassword || ""}
            onChange={(e) => onChange("contact_password", e.target.value)}
            className="mt-1"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Optional. Creates a user account that will require email verification.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <Label htmlFor="address" className="text-sm">
            Address
          </Label>
          <Textarea 
            id="address"
            value={address || ""} 
            onChange={(e) => onChange("address", e.target.value)}
            className="mt-1"
            rows={3}
          />
        </div>
        <div>
          <Label htmlFor="contact-phone" className="text-sm">
            Contact Phone
          </Label>
          <Input 
            id="contact-phone"
            type="tel" 
            value={contactPhone || ""}
            onChange={(e) => onChange("contact_phone", e.target.value)}
            className="mt-1"
          />
        </div>
      </div>
    </div>
  );
};
